module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-cart"
  }, [(_vm.cartLoading) ? _c('div', {
    staticClass: "p-cart--content p-cart--content--info"
  }, [_vm._m(0)]) : (_vm.items && _vm.items.length > 0) ? _c('div', {
    staticClass: "p-cart--content"
  }, [_c('OrderDetails', {
    ref: "OrderDetails",
    staticClass: "p-cart--content__orderDetails"
  }), _vm._v(" "), _c('CartCoupon', {
    ref: "CartCoupon",
    staticClass: "p-cart--content__couponCode"
  }), _vm._v(" "), _c('button', {
    staticClass: "p-cart--content__SignInButton a-Button--Medium a-Button--LightBlue",
    on: {
      "click": _vm.checkout
    }
  }, [_vm._v("\n      " + _vm._s(_vm.userId ? 'Continue' : 'Sign in to continue') + "\n    ")])], 1) : _c('div', {
    staticClass: "p-cart--content p-cart--content--info"
  }, [_c('span', [_c('p', [_vm._v("Your cart is empty.")]), _vm._v(" "), _c('button', {
    staticClass: "a-Button--Medium a-Button--LightBlue",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Go back")])])]), _vm._v(" "), _c('PaymentsOptionsInfo', {
    ref: "PaymentsOptionsInfo"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', [_vm._v("Loading cart...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa0fa18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/pages/Cart.vue
// module id = 524
// module chunks = 2